import { memo, useEffect, useRef, useState } from 'react'
import { useIntl } from 'react-intl'
import { TouchableWithoutFeedback, View } from 'react-native'
import styled from 'styled-components'
import { StyledInput } from '../../../../../elements/input/TextInput/TextInput'
import { cursorText, outlineNone } from '../../../../../style/webStyles'
import messages from '../../../messages'
import { SendButton } from './SendButton'

const initialInputHeight = 20

const TextInputWrapper = styled(View)`
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  box-shadow: 0 0 5px ${(props) => props.theme.colors.gray};
  background: ${(props) => props.theme.colors.white};
  padding: ${(props) => props.theme.spacing.sm}px 0;
  height: ${(props) => initialInputHeight * 2 + props.theme.spacing.sm * 2}px;
  ${cursorText};
`

const TextInput = styled(StyledInput)`
  padding-top: 0;
  padding-bottom: 0;
  background: transparent;
  border: 0;
  flex: 1;
  overflow: hidden;
  justify-content: center;
  ${outlineNone};
`

export const ChatTextInput = memo(({ sendMessage }) => {
  const [inputValue, setInputValue] = useState('')
  const [inputHeight, setInputHeight] = useState(initialInputHeight)

  const intl = useIntl()
  const input = useRef(null)

  const onSubmitEditing = () => {
    const trimmed = inputValue.trim()
    if (trimmed) {
      sendMessage(trimmed)
      setTimeout(() => setInputValue(''), 0)
    }
    input.current.focus()
  }

  useEffect(() => {
    if (!inputValue) {
      setInputHeight(initialInputHeight)
    }
  }, [inputValue])

  return (
    <TouchableWithoutFeedback onPress={() => input.current.focus()}>
      <TextInputWrapper>
        <TextInput
          multiline
          scrollEnabled={false}
          blurOnSubmit={false}
          ref={input}
          style={{ height: inputHeight }}
          value={inputValue}
          placeholder={intl.formatMessage(messages.chatPlaceholder)}
          onKeyPress={({ nativeEvent: { key } }) => key === 'Enter' && onSubmitEditing()}
          onChange={(event) => {
            // This keeps the text centered whether there's 1 line or more.
            setInputHeight(
              Math.min(initialInputHeight * 2, event.nativeEvent.srcElement.scrollHeight),
            )
          }}
          onChangeText={setInputValue}
        />

        {!!inputValue && <SendButton onPress={onSubmitEditing} />}
      </TextInputWrapper>
    </TouchableWithoutFeedback>
  )
})
